{
  "addButtonLabel": "Faʻaopopo vailaʻau",
  "dose": "Togafitiga",
  "dosePlaceholder": "e.g. 500mg or 1 tablet",
  "dropHere": "Tuʻu i le vaega lenei",
  "dropText": "<p>{{fileExtensions}} poʻo le {{fileExtension}} — e oo atu i le {{mb}}MB</p>",
  "dropTitle": "<p><strong>Tuʻu i luga se faila</strong> pe toso ma tufa</p>",
  "frequency": "Taimi masani",
  "manuallyText": "<strong>Faʻaopopo vailaʻau i le lima</strong><p>Faʻaopopo le tasi vailaʻau i le taimi. Faʻaofi le igoa, le fualaʻau ma le taimi e te inu ai.</p>",
  "medicationName": "Igoa o le vailaʻau",
  "medicationPlaceholder": "<p><strong>Fa'amolemole, ulufale i le Igilisi.</strong><br/>Fa'ata'ita'iga: Metformin – 500mg morning and night</p>",
  "nextLabel": "$t(common:next): <b>Talaʻaga</b>",
  "saveButton": "Sefe fualaʻau",
  "select": {
    "as-needed": "Pe a manaʻomia",
    "once-daily": "E tasi i le aso",
    "three-time-daily": "Tolu i le aso",
    "twice-daily": "Fa’alua i le aso"
  },
  "text": "<p>Fa'amolemole ta'u mai so'o se vaila'au, inhaler, tui, po'o se fuala'au fa'aopoopo o lo'o e fa'aaogāina i le taimi nei.</p>\n<p>Oe mafai ona fa'auluina se lisi po'o fa'aopoopo tusi.</p>",
  "title": "Vailaʻau",
  "uploadText": "<strong>Tuʻu i luga se fomaʻi poʻo se lisi</strong>\n<p>Afai ei ai sau lisi mai lau fomaʻi poʻo le faletalavai, fa'aulu se ata po'o se PDF.</p>"
}
